import * as React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';

export default class AuthRoute extends React.PureComponent<RouteProps> {

    render() {
        const { component, ...other } = this.props;
        return (
            <Route
                {...other}
                render={this._renderRoute}
            />
        );
    }

    _renderRoute = routeProps => {
        const { component: Component } = this.props;
        const token = localStorage.getItem('access_token');
        if (!Component || !token || token.length === 0) {
            return (
                <Redirect
                    to={{ pathname: '/login', state: { from: routeProps.location }}}
                />
            );
        }
        return <Component {...routeProps} />;
    }
}



// WEBPACK FOOTER //
// ./src/components/AuthRoute.tsx